module.exports = __webpack_public_path__ + "static/media/footer.770afa44.jpg";